import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'
import sortListStringNum from '../../../../helper/sortLIstStringNum'

// action
import { removeLoading, addLoading } from '../../../commonAction'

const apiGetListRegisterAppGoToCounterReport = `${host}admin/exportJSON/registerAppGoToCounterReport`

export const getListRegisterAppGoToCounterReport = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    TellerName,
    SupervisorName,
    Channel
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
        TellerName,
        SupervisorName,
        Channel
    })

    try {
        const res = await Axios.post(
            apiGetListRegisterAppGoToCounterReport,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_REGISTER_APP_GO_TO_COUNTER_REPORT,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                    TellerName,
                    SupervisorName,
                    Channel
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_REGISTER_APP_GO_TO_COUNTER_REPORT_ERROR,
            () => false
        )
    }
}

export const exportListRegisterAppGoToCounterReport = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
    TellerName,
    SupervisorName,
    Channel
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
        TellerName,
        SupervisorName,
        Channel
    })

    try {
        const res = await Axios.post(
            apiGetListRegisterAppGoToCounterReport,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${sortListStringNum(BranchCodes).join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
